"use client";
import { usePopover } from "../hooks/usePopover";

const PopoverOutput = () => {
  const { popover } = usePopover();

  return popover;
};

export default PopoverOutput;
